import React, { ReactElement, ReactNode } from 'react'
import { ThemeUIStyleObject } from 'theme-ui'
import { Button } from 'ui'

interface TabButtonProps {
  sx?: ThemeUIStyleObject
  isSelected?: boolean
  children: ReactNode
  onClick: () => void
}
export default function TabButton({ sx = {}, isSelected, ...props }: TabButtonProps): ReactElement {
  return (
    <Button
      variant="transparent"
      ariaLabel="tab button"
      sx={{
        padding: '0.1rem 0.8rem 0.1rem 0.8rem',
        borderRadius: '2.4rem',
        fontSize: '1.2rem',
        width: 'fit-content',
        whiteSpace: 'nowrap',
        fontWeight: isSelected ? 700 : 400,
        color: isSelected ? 'blue800' : 'aliceBlue',
        border: '1px solid',
        borderColor: isSelected ? 'blue800' : 'transparent',
        backgroundColor: isSelected ? 'cyan800' : 'blueYonder20',
        boxShadow: isSelected && `0px 0px 0px 1px #000, 0px 0px 0px 2px #63D6FF`,
        '&:hover': {
          backgroundColor: isSelected ? 'cyan800' : 'blueYonder30',
        },
        ...sx,
      }}
      {...props}
    />
  )
}
